export default __webpack_public_path__ + "static/media/setting_icon.fe4f0ef9.svg";